import { useI18n } from 'builder/hooks/useI18n'
import { ColumnName } from 'builder/modules/jobTracking'

import {
  DocumentErrorLine,
  DocumentsContent,
  DocumentsInfoContainer,
  DocumentsInfoSpinner,
  DocumentsInfoText,
  DocumentsLineHead,
  DocumentsLineTitle,
} from './styles'
import { DocumentsList } from './DocumentsList'
import { DocumentUpload } from './DocumentUpload'
import { UploadedDocumentsProps } from './types'
import { TRANSLATION } from './constants'

export const UploadedDocuments = ({
  job,
  isDragging,
  uploadError,
  uploadingFile,
  autoApplyDocuments,
  resumeRefInput,
  coverLetterRefInput,
  isUserOnAutoApplyPlan,
  handleDrop,
  setUploadError,
  handleUploadDocument,
  handleDeleteDocument,
  handleUploadDocumentButton,
}: UploadedDocumentsProps) => {
  const { i18n } = useI18n()

  const ErrorComponent = (
    <DocumentErrorLine onClick={() => setUploadError(null)}>
      <p>{!uploadError?.delete && i18n.t(`${TRANSLATION}.upload_error`)}</p>
      <p>{uploadError?.error}</p>
    </DocumentErrorLine>
  )

  return (
    <DocumentsContent>
      {job?.autoTailoringStatus === 'processing' && (
        <DocumentsInfoContainer>
          <DocumentsInfoSpinner />
          <DocumentsInfoText>{i18n.t(`${TRANSLATION}.sections.documents_info`)}</DocumentsInfoText>
        </DocumentsInfoContainer>
      )}

      <DocumentUpload
        docType="resume"
        refInput={resumeRefInput}
        handleUploadDocumentButton={handleUploadDocumentButton}
        handleUploadDocument={handleUploadDocument}
      />
      <DocumentsList
        isDragging={isDragging}
        uploadedDocumentType="resume"
        documents={autoApplyDocuments.resume}
        uploadingFile={uploadingFile}
        handleDrop={handleDrop}
        handleDeleteDocument={handleDeleteDocument}
      />
      {uploadError?.documentType === 'resume' && ErrorComponent}

      <DocumentUpload
        docType="cover_letter"
        refInput={coverLetterRefInput}
        handleUploadDocumentButton={handleUploadDocumentButton}
        handleUploadDocument={handleUploadDocument}
      />
      <DocumentsList
        isDragging={isDragging}
        uploadingFile={uploadingFile}
        uploadedDocumentType="cover_letter"
        documents={autoApplyDocuments.cover_letter}
        handleDrop={handleDrop}
        handleDeleteDocument={handleDeleteDocument}
      />
      {uploadError?.documentType === 'cover_letter' && ErrorComponent}

      {(job.status === ColumnName.auto_apply || job.autoApplyStatus) && isUserOnAutoApplyPlan && (
        <>
          <DocumentsLineHead>
            <DocumentsLineTitle>
              {i18n.t(`${TRANSLATION}.documents_titles.application_confirmation`)}
            </DocumentsLineTitle>
          </DocumentsLineHead>
          <DocumentsList
            isDragging={false}
            uploadedDocumentType="auto_applied"
            uploadingFile={uploadingFile}
            documents={autoApplyDocuments.auto_applied}
            handleDeleteDocument={handleDeleteDocument}
            handleDrop={handleDrop}
          />
        </>
      )}
    </DocumentsContent>
  )
}
